import React, { useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, btnP } from "../../constants/styles";
import { getLeaseForTenant, getLeaseStatus, leaseStatusColor, leaseStatusLabel } from "../../utils/leaseHelpers";

function TenantsPage() {
  const { t, h, tens, setTens, props, setProps, go, setSelTid, flash, showConfirm, leases, plan } = useContext(Ctx); const hasWa = (plan.features || []).includes("whatsapp");

  const deleteTenant = (tid) => {
    showConfirm(t.deleteTenConfirm, () => {
      api.deleteTenant(tid);
      setTens(tens.filter(t => t.id !== tid));
      setProps(props.map(p => p.tid === tid ? { ...p, occ: false, tid: null } : p));
      flash(t.tenDeleted);
    });
  };

  return <div style={{ paddingTop: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
      <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: 0 }}>{t.tenants}</h2>
      <button onClick={() => go("addTenant")} style={{ background: h.ac, border: "none", color: "#fff", padding: "8px 16px", borderRadius: 10, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>+ Add Tenant</button></div>
    {tens.length === 0 && <div style={{ ...crd(h), textAlign: "center", padding: 30, color: h.sc }}>{t.noTenFound}</div>}
    {tens.map(te => {
      const p = props.find(x => x.tid === te.id);
      const tLease = getLeaseForTenant(leases, te.id);
      const tLeaseStatus = tLease ? getLeaseStatus(tLease) : null;
      return <div key={te.id} style={crd(h)}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 18, background: h.ac, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14, fontWeight: 700 }}>{te.name[0]}</div>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span style={{ color: h.tx, fontSize: 14, fontWeight: 600 }}>{te.name}</span>
              {te.verified ? <span title="Verified" style={{ color: h.gn, fontSize: 14 }}>{"\u2713"}</span> : null}
            </div>
            <div style={{ color: h.sc, fontSize: 11 }}>{te.ph}{te.id_type && te.id_number ? ` \u00B7 ${te.id_type.toUpperCase()}` : ""}</div>
          </div>
          {tLeaseStatus ? <span style={{ marginLeft: "auto", ...bdg(`${leaseStatusColor(tLeaseStatus, h)}20`, leaseStatusColor(tLeaseStatus, h)) }}>{leaseStatusLabel(tLeaseStatus, t)}</span>
            : <span style={{ marginLeft: "auto", ...bdg(`${h.sc}15`, h.sc) }}>{t.noLease}</span>}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: h.tx, marginBottom: 10, paddingBottom: 10, borderBottom: `1px dashed ${h.bd}` }}>
          <span>{t.property}: <b>{p ? p.addr.split(",")[0] : t.none}</b></span>
          <span>{t.joined}: {te.join}</span>
        </div>
        <button onClick={() => { setSelTid(te.id); go("tenantPayHistory"); }} style={{ width: "100%", padding: 10, marginBottom: 10, borderRadius: 10, border: `1px solid ${h.ac}`, background: `${h.ac}10`, color: h.ac, cursor: "pointer", fontSize: 13, fontWeight: 600 }}>{"🧾 " + t.viewPayHistory}</button>
        {hasWa && <button onClick={() => {
          const phNorm = te.ph.replace(/\D/g, "");
          const finalPh = phNorm.length === 10 ? "91" + phNorm : phNorm;
          // FIX #20: Don't include password in WhatsApp invite — security risk
          const msg = `Hello ${te.name},%0AWelcome to our House Rentals App! 🏠%0AHere are your login details:%0ALink: https://lacto.in%0ARole: Tenant%0APhone Number: ${te.ph}%0APlease contact your landlord for your login password.`;
          window.open(`https://wa.me/${finalPh}?text=${msg}`, "_blank");
        }} style={{ width: "100%", padding: 10, marginBottom: 10, borderRadius: 10, border: "none", background: "#25D366", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>💬 Invite via WhatsApp</button>}
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => { localStorage.setItem("editTid", te.id); go("editTenant"); }} style={{ flex: 1, padding: 8, borderRadius: 8, border: "none", background: `${h.ac}15`, color: h.ac, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"✏️ " + t.edit}</button>
          <button onClick={() => deleteTenant(te.id)} style={{ flex: 1, padding: 8, borderRadius: 8, border: "none", background: `${h.rd}15`, color: h.rd, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"✕ " + t.delete}</button>
        </div>
      </div>;
    })}
  </div>;
}

export default TenantsPage;
